module.exports = __webpack_public_path__ + "static/media/drone.e6930950.png";